// extracted by mini-css-extract-plugin
export default {"container":"Price_container__bL1Ec","textContainer":"Price_textContainer__FgwTC","buttonsContainer":"Price_buttonsContainer__zM1-E"};